export default {
  POI_UNMOUNT: "POI_UNMOUNT",
  INIT_POI: "INIT_POI",
  FETCH_NEXT: "FETCH_NEXT",
  FETCH_NEXT_DONE: "FETCH_NEXT_DONE",
  FETCH_POI: "FETCH_POI",
  FETCH_POI_DONE: "FETCH_POI_DONE",
  FETCH_AVAILABILITY: "FETCH_AVAILABILITY",
  FETCH_AVAILABILITY_DONE: "FETCH_AVAILABILITY_DONE",
  FETCH_NEARBY_DONE: "FETCH_NEARBY_DONE",
  HOVER_PLACE: "HOVER_PLACE",
  FETCH_PARTNER_ACTIVITIES: "FETCH_PARTNER_ACTIVITIES",
  FETCH_PARTNER_ACTIVITIES_DONE: "FETCH_PARTNER_ACTIVITIES_DONE",
  FETCH_BOOKMARK_LISTS_DONE: "FETCH_BOOKMARK_LISTS_DONE",
  FETCH_BOOKMARK_LISTS: "FETCH_BOOKMARK_LISTS",
  CREATE_BOOKMARK: "CREATE_BOOKMARK",
  CREATE_BOOKMARK_DONE: "CREATE_BOOKMARK_DONE",
  CREATE_LIST: "CREATE_LIST",
};



// WEBPACK FOOTER //
// ./assets/pois/constants/actions.js